/* eslint eqeqeq: "off" */
import React, { useEffect } from "react";
import { Col, Image, Row } from "antd";
// import { inclusions, activityDetailsList } from "./data";
import useMedia from "use-media-antd-query";
// import FAQ from "./faq";
// import PackageFooter from "./activity-footer";
import { useHistory } from "react-router";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { loadActivitiesList } from "../../store/activities-list/actions";

const ActivityDetails = () => {
  const media = useMedia();
  const history = useHistory();
  const dispatch = useDispatch();

  //store integrations

  useEffect(() => {
    dispatch(loadActivitiesList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { activities_list = [] } = useSelector((state) => state.Activities);
  const activitiesDetails =
    activities_list &&
    activities_list.queryResult &&
    activities_list.queryResult.length > 0
      ? activities_list.queryResult.map((data) => {
          return {
            destinationId: data.destinationId,
            lowestPrice: data.lowestPrice,
            activities: data.noOfActivities,
            packageName: data.destinationName,
            imageUrl:
              data.image && data.image.length > 0 ? data.image[0].imageUrl : "",
            // imageUrl: data.images && imageUrl !== "" ? imageUrl : "",
          };
        })
      : [];

  return (
    <React.Fragment>
      <Col md={24} lg={24} xl={24} xxl={24}>
        <Row>
          <Col
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            sm={24}
            xs={24}
            className="pl-5 pr-5 pt-3 pb-3"
          >
            <div
              style={{
                fontFamily: "Poppins",
                marginBottom: "1.5rem",
                //   boxShadow: "1px 1px 1px 2px lightgray",
              }}
            >
              <h2 className="text-[24px] text-start font-black">
                Create Experiences with Top Indian Destinations
              </h2>
              <span className="text-[14px]">
                From trekking to skiing, indulge in every electrifying activity
                of sublimely divine India.
              </span>
            </div>

            <Row className="flex flex-row">
              {activitiesDetails.map((data, index) => {
                return (
                  <Col
                    md={12}
                    lg={6}
                    xl={6}
                    xxl={6}
                    sm={24}
                    xs={24}
                    className={
                      media !== "md" || media !== "sm" || media !== "xs"
                        ? "pr-5 pb-5 cursor-pointer"
                        : index == 5
                        ? "pr-5 pb-5 cursor-pointer"
                        : "pr-5 pb-5 cursor-pointer"
                    }
                    onClick={() =>
                      history.push({
                        pathname: `/destinations/destination-in-${data.packageName}`,
                        state: data,
                      })
                    }
                  >
                    <div
                      style={{
                        fontFamily: "Poppins",
                        // border: "1px solid rgba(200, 203, 206, 0.81)",
                      }}
                      className="group h-[280px] relative rounded-2xl overflow-hidden shadow-lg cursor-pointer"
                      key={index}
                    >
                      <Image
                        //   src={data.imageUrl}
                        src={data.imageUrl}
                        preview={false}
                        height={280}
                        width={"100%"}
                        className="w-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-300 text-start relative cursor-pointer mb-3"
                      />
                      <div className="absolute inset-0 bg-black bg-opacity-30 group-hover:bg-opacity-50 transition-colors duration-300"></div>
                      {data.activities && (
                        <div className="absolute top-3 left-3 group-hover:opacity-0 transition-opacity duration-300 bg-black text-white text-[10px] font-semibold py-1 px-2 rounded-full">
                          {data.activities} Destinations
                        </div>
                      )}
                      {/* Static City Text at bottom-left inside image */}
                      <div
                        className={
                          data.packageName &&
                          data.packageName.length > 5 &&
                          data.packageName.length < 12
                            ? "absolute bottom-2 left-[75px] text-[18px] group-hover:opacity-0 transition-opacity text-white font-semibold"
                            : data.packageName && data.packageName.length > 12
                            ? "absolute bottom-2 left-[50px] text-[18px] group-hover:opacity-0 transition-opacity text-white font-semibold"
                            : "absolute bottom-2 left-[101px] text-[18px] group-hover:opacity-0 transition-opacity text-white font-semibold"
                        }
                      >
                        {data.packageName}
                      </div>

                      <div className="absolute top-20 left-7 right-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="flex items-center justify-between">
                          <div className="text-white">
                            <p className="text-sm">Discover</p>
                            <p className="text-sm">Destinations In</p>
                            <h2 className="text-lg font-semibold">
                              {data.packageName}
                            </h2>
                          </div>
                          <div className="bg-[#eb3e43] text-white w-8 h-8 rounded-full flex items-center justify-center transition-transform duration-300">
                            →
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="text-[14px] mt-3 text-center text-[#eb3e43] font-semibold"
                    >
                      Starting At {data.startingFrom}
                    </div> */}
                  </Col>
                );
              })}
            </Row>
            {/* <FAQ /> */}
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};

ActivityDetails.propTypes = {
  location: PropTypes.any,
};

export default ActivityDetails;
